import { ApiErrorTranslationKeys } from '@/lib/api/apiErrorTranslationKeys.ts';

/**
 * Backend error keys specific to consent templates. Detect these on 400 responses
 * with `isKnownBackendErrorKey` to show tailored messages to the user.
 *
 * Values are `TranslationKey` enum member names — see `hasErrorKey` for why the
 * dotted variant (`error.consent_template.in_use`) never matches.
 */
export const ConsentTemplateErrorKeys = {
  /** PUT was sent against an archived (no longer current) template version. */
  NOT_CURRENT: 'CONSENT_TEMPLATE_NOT_CURRENT',
  /** DELETE was attempted on a template still pinned to at least one tour. */
  IN_USE: 'CONSENT_TEMPLATE_IN_USE',
} as const satisfies Record<string, keyof typeof ApiErrorTranslationKeys>;
